import React, { FC } from 'react';

import { LoadableProps } from './models';

const Loadable: FC<LoadableProps> = ({ isActive, children }) => (isActive ? <>{children}</> : null);

export default Loadable;
